'use client'

import { useEffect, useRef, useState } from 'react'

export const StatsItem = ({
  number,
  suffix,
  title,
}: {
  number: number
  suffix: string
  title: string
}) => {
  const [currentNumber, setCurrentNumber] = useState(0)
  const [isVisible, setIsVisible] = useState(false)
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !isVisible) {
          setIsVisible(true)
        }
      },
      { threshold: 0.1 }
    )

    if (ref.current) {
      observer.observe(ref.current)
    }

    return () => observer.disconnect()
  }, [isVisible])

  useEffect(() => {
    if (isVisible) {
      const duration = 3000 // 2 seconds
      const steps = 60 // 60 steps for smooth animation
      const increment = number / steps
      const stepDuration = duration / steps

      let current = 0
      const timer = setInterval(() => {
        current += increment
        if (current >= number) {
          setCurrentNumber(number)
          clearInterval(timer)
        } else {
          setCurrentNumber(Math.floor(current))
        }
      }, stepDuration)

      return () => clearInterval(timer)
    }
  }, [isVisible, number])

  return (
    <div ref={ref} className="flex flex-col items-center px-8">
      <h2 className="font-bold text-primary font-secondary lg:text-5xl text-3xl">
        {currentNumber}
        {suffix}
      </h2>
      <p className="font-secondary text-gray-400">{title}</p>
    </div>
  )
}
